import { Box, Typography } from "@mui/material";
import { useComponentContext } from "../../../contexts/ComponentContext";
import { useLocation, matchPath } from "react-router-dom";

const pathToComponentId: Record<string, string> = {
  "/bookings": "bookings",
  "/bookings/church": "churchBookings",
  "/bookings/funeral": "funeralBookings",
  "/bookings/funeral-home": "funeralHomeBookings",
  "/bookings/other": "otherBookings",
  "/bookings/conference": "conferenceBookings",
  "/bookings/event": "eventBookings",

  "/dashboard": "dashboard",
  "/client-portal-dashboard": "clientPortalDashboard",
  "/main-dashboard": "mainDashboard",

  "/stream-management": "streamManagement",
  "/stream-management/add": "addStream",
  "/stream-management/view": "viewStream",
  "/stream-management/view/:id/edit": "editStream",
  "/stream-management/view/:id/stream-report": "streamReport",
  "/stream-management/view/:id/callsheet": "callSheet",
  "/stream-management/ten-day-forecast": "tenDayForecast",

  "/venues": "venues",
  "/venues/add": "addVenue",
  "/venues/view": "viewVenue",
  "/venues/view/:id/edit": "editVenue",

  "/contacts": "contacts",
  "/contacts/add-company-contact": "addCompanyContact",
  "/contacts/add-individual": "addIndividualContact",
  "/contacts/company/view": "companyView",
  "/contacts/individual/view": "individualView",
  "/contacts/company/edit": "editCompany",
  "/contacts/individual/edit": "editIndividual",

  "/companies": "companies",
  "/companies/add": "addCompany",
  "/companies/:id": "viewCompany",
  "/companies/:id/edit": "editCompanyForm",

  "/crew-management": "crewManagement",
  "/crew-management/all-crew": "allCrew",
  "/crew-management/checklists": "checklists",
  "/crew-management/checklists/:id": "viewChecklist",
  "/crew-management/checklists/:checklistId/sections/:sectionId":
    "viewChecklistItems",
  "/crew-management/crew-ratings": "crewRatings",
  "/crew-management/rates": "rateCards",
  "/crew-management/view/:id": "viewCrewMember",

  "/gear-management": "gearManagement",
  "/settings": "settings",
  "/sales": "sales",
  "/configurations": "configurations",
};

const Footer = () => {
  const { componentsData } = useComponentContext();
  const location = useLocation();

  // 1️⃣ Try to find a match from the mapping
  const matchedPath = Object.keys(pathToComponentId).find((path) =>
    matchPath({ path, end: false }, location.pathname),
  );

  // 2️⃣ If no match, dynamically derive componentId from the first segment
  const componentId = matchedPath
    ? pathToComponentId[matchedPath]
    : location.pathname.split("/").filter(Boolean)[0] || "dashboard";

  const metadata = componentsData[componentId] || {
    componentName: componentId || "Unknown Component",
    leadName: "Not Assigned",
    backupDeveloper: "Not Assigned",
    version: "N/A",
  };

  // 3️⃣ Don't render footer if no metadata found
  if (!metadata) return null;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 1,
        borderTop: "1px solid #e0e0e0",
        mt: 2,
        backgroundColor: "#f9f9f9",
      }}
    >
      <Box>
        <Typography sx={{ fontWeight: "bold" }}>
          {metadata.componentName}
        </Typography>
        <Typography variant="body2">
          Lead: {metadata.leadName || "Not Assigned"} | Backup:{" "}
          {metadata.backupDeveloper || "Not Assigned"}
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
